"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
class Export extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isExporting: false,
        };
        this.beginExport = this.beginExport.bind(this);
        this.poller = null;
    }
    beginExport() {
        this.setState({ isExporting: true });
        const { createCampaignExport, keyword, campaignStatus, campaignType } = this.props;
        let status;
        switch (campaignStatus) {
            case 'archived':
                status = 'ARCHIVED';
                break;
            case 'drafts':
                status = 'DRAFT';
                break;
            case 'published':
                status = 'PUBLISHED';
                break;
            case 'all':
            default:
                status = undefined;
        }
        let type;
        switch (campaignType) {
            case 'api':
                type = 'API';
                break;
            case 'automated':
                type = 'AUTOMATED';
                break;
            case 'scheduled':
                type = 'SCHEDULED';
                break;
            case 'all':
            default:
                type = undefined;
        }
        createCampaignExport(keyword, status, type);
    }
    componentWillUnmount() {
        if (this.poller) {
            clearInterval(this.poller);
            this.poller = null;
        }
    }
    componentDidUpdate(prevProps) {
        const current = this.props.currentExport;
        const previous = prevProps.currentExport;
        if ((!previous && current) || (previous && current && previous.id !== current.id)) {
            this.poller = setInterval(() => {
                if (this.props.currentExport) {
                    this.props.fetchCampaignExport(current.id);
                }
            }, 1000);
        }
        if (previous && previous.done) {
            return;
        }
        if (current && current.done) {
            if (this.poller) {
                clearInterval(this.poller);
                this.poller = null;
            }
            this.setState({ isExporting: false });
            if (current.error === null && current.URL) {
                const anchor = document.createElement('a');
                anchor.setAttribute('href', current.URL);
                anchor.setAttribute('download', '');
                anchor.click();
            }
        }
    }
    render() {
        const { isExporting } = this.state;
        if (isExporting) {
            return (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                React.createElement(src_1.Text, { size: "small", text: "Processing...", textStyle: { color: src_1.steel, marginRight: '6px' } }),
                React.createElement(src_1.DownloadIcon, { style: { color: src_1.steel } })));
        }
        return React.createElement(src_1.DownloadIcon, { style: { cursor: 'pointer' }, onClick: this.beginExport });
    }
}
const mapStateToProps = (state) => ({
    currentExport: state.campaignExport.current,
});
const mapDispatchToProps = (dispatch) => ({
    createCampaignExport: (keyword, status, triggerType) => {
        return dispatch(actions_1.createCampaignExport(keyword, status, triggerType));
    },
    fetchCampaignExport: (id) => {
        return dispatch(actions_1.fetchCampaignExport(id));
    },
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Export);
